import { render } from "./test_mic_camera.vue?vue&type=template&id=a8e3640a&scoped=true"
import script from "./test_mic_camera.vue?vue&type=script&lang=js"
export * from "./test_mic_camera.vue?vue&type=script&lang=js"

import "./test_mic_camera.vue?vue&type=style&index=0&id=a8e3640a&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\discussion-guru\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8e3640a"]])

export default __exports__